<template>
  <div v-bind="$attrs">
    <slot
      v-if="title"
      name="title"
      v-bind="{ title }"
    >
      <component
        :is="`h${level}`"
        :class="[titleClass]"
      >
        {{ $t(title) }}
      </component>
    </slot>
    <slot
      v-if="description"
      name="description"
      v-bind="{ description }"
    >
      <div
        :class="{ hidden: !hasDescription(description) }"
        class="mb-3 mt-2 font-light"
      >
        {{ $t(description) }}
      </div>
    </slot>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  level?: number;
  title?: string;
  titleClass?: string;
  description?: string;
}

withDefaults(defineProps<Props>(), {
  level: 2,
  title: '',
  titleClass: '',
  description: '',
});

const slots = useSlots();

const hasDescription = (descriptionProp: string) => !!descriptionProp || slots.description?.();
</script>
